import { render, staticRenderFns } from "./DiagnosticSelectClinic.vue?vue&type=template&id=6019f030&"
import script from "./DiagnosticSelectClinic.vue?vue&type=script&lang=js&"
export * from "./DiagnosticSelectClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports